import React, { useEffect, useRef, useState } from 'react';
import { replaceItemAtIndex } from 'utils/common';


const useCheckboxList = (items: any[]) => {
    const lastChecked = useRef<number | null>(null);
    const [checked, setChecked] = useState(items.map(() =>  false));

    useEffect(() => {
        setChecked(items.map(() =>  false));
    }, [items]);

    const checkAll = (event: React.ChangeEvent<HTMLInputElement>) => setChecked(old => old.map(() => event.target.checked));

    const uncheckAll = () => setChecked(old => old.map(() => false));

    const checkOne = (idx: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = (e.target as HTMLInputElement).checked;

        if (lastChecked.current !== null && (e.nativeEvent as KeyboardEvent).shiftKey) {
            setChecked(old => {
                const start = Math.min(lastChecked.current!, idx);
                const end = Math.max(lastChecked.current!, idx);
                const temp = [...old];

                for (let i = start; i <= end; i++) {
                    temp[i] = checked;
                }

                return temp;
            });
        } else {
            setChecked(old => replaceItemAtIndex(old, idx, checked));
        }

        lastChecked.current = idx;
    };

    const getItems = () => items.filter((_, i) => checked[i]);

    return {
        checkedAll: checked.length ? Object.values(checked).every(Boolean) : false,
        checkedSome: new Set(Object.values(checked)).size > 1,
        countChecked: checked.filter(Boolean).length,
        checked,
        checkOne,
        checkAll,
        getItems,
        uncheckAll,
    };
};

export default useCheckboxList;
